import { render, staticRenderFns } from "./OrderComplain.vue?vue&type=template&id=c5bdd0f4&scoped=true"
import script from "./OrderComplain.vue?vue&type=script&lang=ts"
export * from "./OrderComplain.vue?vue&type=script&lang=ts"
import style0 from "./OrderComplain.vue?vue&type=style&index=0&id=c5bdd0f4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../../../DATA/projects/nguonhangchina/client/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c5bdd0f4",
  null
  
)

export default component.exports